import React from "react";
import StepHeader from "../components/StepHeader";
import OptionCard from "../components/OptionCard";
import OptionGroup from "../components/OptionGroup";
import ContinueButton from "../components/ContinueButton";
import { BUSINESS_TYPES } from "../content";

/** C-04 — only shown when the company answered Yes to both questions. */
function BusinessTypeStep({ value, onChange, onContinue, onBack, onClose, busy, step, totalSteps }) {
  return (
    <>
      <StepHeader title="Business type" onBack={onBack} onClose={onClose} step={step} totalSteps={totalSteps} />

      <div className="kv-body">
        <p className="kv-eyebrow">Both criteria met</p>
        <h2 className="kv-title">What is your business type?</h2>

        <OptionGroup label="Business type">
          {BUSINESS_TYPES.map((type) => (
            <OptionCard
              key={type.value}
              icon={type.icon}
              title={type.title}
              selected={value === type.value}
              onSelect={() => onChange(type.value)}
              disabled={busy}
              compact
            />
          ))}
        </OptionGroup>
      </div>

      <ContinueButton onClick={onContinue} disabled={!value} busy={busy} />
    </>
  );
}

export default BusinessTypeStep;
